import { styled, css, getDSColor } from '../theme';
import { StyledDividerProps } from './divider.types';

export const StyledDivider = styled.hr<StyledDividerProps>`
  ${({ theme, $vertical, $fill }) => css`
    ${$vertical
      ? css`
          min-width: 1px;
        `
      : css`
          width: 100%;
          min-height: 1px;
        `}

    margin: 0;
    border: none;
    background-color: ${getDSColor(theme, $fill)};
  `}
`;
